import { HexContainer } from '../hex-container/hex-container';
import DefaultHexImage from '../../../../assets/face-user.svg?react';
import './authentication-header.less';
import { Banner } from '@imprivata-cloud/design-system';
import type { BannerProps } from 'src/containers/Banner/banner';
import type { NotificationBannerProps } from 'src/components/notificationBanner/NotificationBanner';

interface AuthenticationHeaderProps {
  hexImage?: React.ReactNode;
  logoUrl?: React.ReactNode;
  banner?: NotificationBannerProps;
}

export const AuthenticationHeader = ({
  hexImage = <DefaultHexImage />,
  logoUrl,
  banner,
}: AuthenticationHeaderProps) => {
    return (
    <div className="authn-layout-header">
      {banner && (
        <Banner
          message={banner?.description}
          title={banner?.message}
          type={
            banner?.type === 'error' || banner?.type === 'warning'
              ? 'warning'
              : banner?.type as BannerProps['status']
          }
          className="authentication-banner"
        />
      )}
      <span className="authn-layout-header-logo">{logoUrl}</span>
      <HexContainer className="authn-layout-header-hex" icon={hexImage} />
    </div>
  );
};
